// extracted by mini-css-extract-plugin
export var card = "_m1-5";
export var cardSelected = "_m1-4";
export var image = "_m1-3";
export var modal = "_m1-0";
export var modalContent = "_m1-1";
export var table = "_m1-2";